// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import router from './router';
import firebase from 'firebase/app';
import '../theme/index.css'
import ElementUI from 'element-ui';
import 'vue-awesome/icons';
import Icon from 'vue-awesome/components/Icon'
import locale from 'element-ui/lib/locale/lang/en'
import VueDragDrop from 'vue-drag-drop';

Vue.config.productionTip = false;
Vue.config.devtools = true;
Vue.component('icon', Icon)
Vue.use(ElementUI, { locale });
Vue.use(VueDragDrop);
let app;
var config = {
  apiKey: 'AIzaSyD8bytB8Dlr8u3azCe41ED9GUSBUt3jqrE',
  authDomain: 'operations-60be9.firebaseapp.com',
  databaseURL: 'https://operations-60be9.firebaseio.com',
  projectId: 'operations-60be9',
  storageBucket: '',
  messagingSenderId: '487360817529'
};

firebase.initializeApp(config);

export const database = firebase.database()
export const auth = firebase.auth()

firebase.auth().onAuthStateChanged(function (user) {
  console.log(user)
  if (!app) {
    /* eslint-disable no-new */
    app = new Vue({
      el: '#app',
      template: '<App/>',
      components: { App },
      router
    });
  }
});



// WEBPACK FOOTER //
// ./src/main.js